import type { ReactElement } from 'react'
import type { PropsWithAriaLabel, PropsWithAriaLabelledBy } from '../../types'
import type { NamedIconComponentType } from '../icon'
import type { BaseButtonProps } from './base-button'
import { ButtonVariants } from './base-button'

export enum IconButtonVariants {
  primary = ButtonVariants.primary,
  secondary = ButtonVariants.secondary,
  neutral = ButtonVariants.neutral,
  floating = ButtonVariants.floating,
  critical = ButtonVariants.critical,
  transparent = 'transparent',
}

export enum IconButtonSize {
  xxsmall = 'xxs',
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
}

export type IconButtonVariantsType = `${IconButtonVariants}`
export type IconButtonSizeType = `${IconButtonSize}`

type OmittedBaseButtonTypes =
  | 'aria-label'
  | 'aria-labelledBy'
  | 'size'
  | 'variant'
  | 'trailingIcon'
  | 'leadingIcon'
  | 'loadingIndicatorSize'
  | 'block'
  | 'label'
  | 'children'

interface IconButtonBaseProps extends Omit<BaseButtonProps, OmittedBaseButtonTypes> {
  icon: NamedIconComponentType
  size?: IconButtonSizeType
  variant?: IconButtonVariantsType
}

export type IconButtonProps =
  | (PropsWithAriaLabel & IconButtonBaseProps)
  | (PropsWithAriaLabelledBy & IconButtonBaseProps)

export interface ButtonProps extends Omit<BaseButtonProps, 'loadingIndicatorSize'> {}

export type ButtonComponentType = ReactElement<ButtonProps>
